const HEADER_HEIGHT = 170;
const FOOTER_HEIGHT = 48;
const BLOCKS_GAP = 4;
const PAGE_PADDINGS_X = 20;
const DEFAULT_HEIGHT = 866;
export const getContainerHeight = (minHeight) => ({
    height: `calc(100vh - ${HEADER_HEIGHT + FOOTER_HEIGHT + BLOCKS_GAP + PAGE_PADDINGS_X}px)`,
    minHeight: `${minHeight || DEFAULT_HEIGHT}px`,
});
//# sourceMappingURL=getContainerHeight.js.map